<!--
 * @Description: 关联客户代码
 * @Author: cxh
 * @Date: 2022-05-07 17:55:14
 * @LastEditTime: 2023-02-16 16:32:12
 * @LastEditors: cxh
-->
<template>
  <CosModal v-model:visible="visible" title="关联客户代码" width="1000px" @ok="handleSubmit" :confirmLoading="loading">
    <a-spin :spinning="loading">
      <a-form :model="editForm" ref="formRef" v-if="visible" autocomplete="off">
        <a-form-item name="customerName" label="客户名称" :rules="[{ required: true, message: '请输入' }]">
          <a-input v-model:value="editForm.customerName" :disabled="true" />
        </a-form-item>
        <dc-layout-card title="客户代码详情">
          <template #subTitle>
            <a-button type="primary" @click="hanleAdd" ghost>新增</a-button>
          </template>
          <template v-for="(item, index) in editForm.arkCodes" :key="index">
            <dc-form-item :label="`子客户代码${index + 1}`" :span="24">
              <div class="flex">
                <codeSelect
                  v-model:label="item.arkCode"
                  allowClear
                  :value="item"
                  :firstData="firstData"
                  :disabledData="disabledData"
                  :cosId="editForm.cosId"
                  @change="getQueryCodeRel(item)"
                />
                <a-button type="text" danger style="padding: 0 0 0 12px" @click="hanleDel(index)">删除</a-button>
              </div>
              <p style="color: #e6a23c">{{ item.infoMessage }}</p>
            </dc-form-item>
          </template>
          <a-col :span="24" v-if="!editForm.arkCodes || !editForm.arkCodes.length">
            <dc-layout-empty type="nothing" />
          </a-col>
        </dc-layout-card>
      </a-form>
    </a-spin>
  </CosModal>
</template>
<script lang="ts" setup>
import { computed, ref } from 'vue'
import { DcMessage } from '@dc-platform/dc-components'
import codeSelect from './codeSelect.vue'
import { queryCodeRel, getCosIdBindCode, customerCodeDelectSelect, bindARKCode } from '@/api/gucangSales/customerCenter'
const visible = ref<boolean>(false)
const loading = ref<boolean>(false)
const formRef = ref()
interface codeItem {
  cosId?: string
  customerName?: string
  infoMessage?: string
  arkCodes?: {
    arkCode?: string
    infoMessage?: string
  }[]
}
const editForm = ref<codeItem>({
  arkCodes: []
})
const firstData = ref<any[]>([])
const bindCodePrev = ref('')
const emit = defineEmits(['success'])
const handleSubmit = () => {
  formRef.value?.validate().then(async () => {
    loading.value = true
    const arkCode: any = []
    editForm.value.arkCodes?.forEach((item: any) => {
      if (item.arkCode) {
        arkCode.push(item.arkCode)
      }
    })
    bindARKCode({
      cosId: editForm.value.cosId,
      arkCode
    })
      .then((res) => {
        // 判断是否有修改，提示语不同
        if (bindCodePrev.value === arkCode.join(',')) {
          DcMessage.success('操作成功')
        } else {
          DcMessage.success('变更关联关系成功')
        }
        emit('success')
        visible.value = false
      })
      .finally(() => {
        loading.value = false
      })
  })
}
const toggle = (rows: codeItem) => {
  editForm.value = {
    cosId: rows.cosId,
    customerName: rows.customerName
  }
  visible.value = true
  fetchByCosId()
}
const disabledData = computed(() => {
  const code = editForm.value.arkCodes?.map((item) => item.arkCode)
  return code
})
// 校验code
const getQueryCodeRel = (v: any) => {
  if (v.arkCode) {
    queryCodeRel(v.arkCode).then((res) => {
      if (res.data && res.data.cosId && res.data.cosId !== editForm.value.cosId) {
        v.infoMessage = `【该客户代码已经绑定在（${res.data.customerName}）名下，请注意】`
      } else {
        v.infoMessage = ''
      }
    })
  } else {
    v.infoMessage = ''
  }
}
// 获取客户关联的客户代码
const fetchByCosId = async () => {
  loading.value = true
  try {
    await fetchCodeBySellor()
  } catch (error) {
    console.log('getData error: ', error)
  }
  setTimeout(() => {
    getCosIdBindCode({
      cosId: editForm.value.cosId,
      pageNumber: 1,
      pageSize: 500
    })
      .then((res) => {
        if (res.data.items && res.data.items.length) {
          editForm.value.arkCodes = res.data.items
          const arkCode: string[] = []
          res.data.items.forEach((item: any) => arkCode.push(item.arkCode))
          bindCodePrev.value = arkCode.join(',')
        } else {
          editForm.value.arkCodes = [{}]
          bindCodePrev.value = ''
        }
      })
      .finally(() => {
        loading.value = false
      })
  })
}
// 获取客户负责人关联的客户代码列表
const fetchCodeBySellor = () => {
  return new Promise((resolve) => {
    customerCodeDelectSelect({
      pageNumber: 1,
      pageSize: 100,
      stage: [2, 3, 4],
      cosId: editForm.value.cosId
    }).then((res) => {
      firstData.value = res.data.items
      resolve(res.data)
    })
  })
}
const hanleAdd = () => {
  editForm.value.arkCodes?.push({})
}
const hanleDel = (index: number) => {
  editForm.value.arkCodes?.splice(index, 1)
}
defineExpose({
  toggle
})
</script>
<script lang="ts">
export default { name: 'RelationCode' }
</script>
<style lang="scss" scoped>
.clueMerge {
  .list {
    margin: 20px 0;
    li {
      display: flex;
      align-items: center;
    }
    .name {
      flex: 1;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
</style>
